const NAMESPACE = 'logging';

export const selectHasContentCardImpressionReported =
  (contentCardId) => (state) =>
    !!state?.[NAMESPACE]?.contentCards?.impressions?.[contentCardId] || false;
export const selectCardsValidationErrors = (state) =>
  state?.[NAMESPACE]?.contentCards?.errors || [];
